module.exports = __webpack_public_path__ + "static/media/close-grey.e0316dea.svg";